export default __webpack_public_path__ + "static/media/squares500.eb7df149.jpg";